let con = {
  development: {
    apihost: "http://192.168.10.151:91",
  },
  test: {
    apihost: "http://172.16.5.151:91",
  },
  production: {
    apihost: "http://nasfytjapi.mhksd.com.cn:8891",
  }
};

let config = con[process.env.REACT_APP_ENV];
console.log(config, '55555');
export { config };
